import { render, staticRenderFns } from "./AvatarsModal.vue?vue&type=template&id=2317c3d6&"
import script from "./AvatarsModal.vue?vue&type=script&lang=js&"
export * from "./AvatarsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports